module.exports = __webpack_public_path__ + "static/media/projectsImage4.6902a439.jpg";